import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Sentiment } from 'ideta-library/lib/common/aicm';

// sentimentsWithResponses[sentiment][0] -> reactions
// sentimentsWithResponses[sentiment][1] -> response
// sentimentsWithResponses[sentiment][2] -> response_visible
@Component({
  selector: 'app-sentiment-analysis-options',
  templateUrl: './sentiment-analysis-options.component.html',
  styleUrls: ['./sentiment-analysis-options.component.scss']
})
export class SentimentAnalysisOptionsComponent implements OnInit {
  @Input() selectedSentiment: Sentiment;
  @Input() inCreateCampaign: boolean;
  @Output() selectedSentimentChange: EventEmitter<Sentiment>;

  emojiSelector: {
    [key in Sentiment]: string;
  };

  constructor() {
    this.selectedSentiment = 'neutral';
    this.selectedSentimentChange = new EventEmitter();
    this.emojiSelector = { positive: '😀', neutral: '😐', negative: '🙁' };
  }

  ngOnInit(): void {}

  selectSentiment(sentiment: Sentiment) {
    if (this.selectedSentiment !== sentiment) {
      this.selectedSentiment = sentiment;
    }
    this.selectedSentimentChange.emit(this.selectedSentiment);
  }
}
